// Status Badge Component
const StatusBadge = ({ status }) => {
  const statusLabels = {
    interessent: "Interessent",
    aktiv: "Aktiv",
    abgebrochen: "Abgebrochen",
    nicht_angetreten: "Nicht angetreten",
    pausiert: "Pausiert",
    abgeschlossen: "Abgeschlossen",
    geplant: "Geplant",
    laufend: "Laufend",
    bestanden: "Bestanden",
    nicht_bestanden: "Nicht bestanden",
    offen: "Offen",
    erledigt: "Erledigt",
    selbstzahler: "Selbstzahler",
    einrichtung: "Einrichtung",
    bildungsgutschein: "Bildungsgutschein",
    teilweise_bezahlt: "Teilweise bezahlt",
    vollstaendig_bezahlt: "Vollständig bezahlt"
  };

  return (
    <span className={`badge status-${status}`} data-testid={`status-badge-${status}`}>
      {statusLabels[status] || status}
    </span>
  );
};

export default StatusBadge;
